import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { reserveButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a href={`https://forms.gle/qKSU2EvTiXQyvK257`} target="_blank">
              <CFView hover>
                <CFImage src={reserveButton} maxWidth="77vw" alt="About" />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a href={`https://forms.gle/qKSU2EvTiXQyvK257`} target="_blank">
              <CFView hover>
                <CFImage src={reserveButton} maxHeight="6.5vh" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
